/* ============================================================
   DATA BABY SPA

   Letakkan di: app/layanan/baby-spa/baby-spa.js

   ============================================================
   SUMBER ISINYA

   Nomor telepon dan kalimat "silakan hubungi nomor di bawah untuk
   melakukan reservasi" disalin dari halaman lama di
   rsjmc.id/baby-spa.

   Kalimat pengantarnya diambil dari layananList.babySpaDesc di
   dictionary.js - keterangan yang sudah dipakai RS sendiri di menu
   dan akordeon beranda.

   ⚠️ SELEBIHNYA TIDAK ADA. Halaman lama hanya memuat satu kalimat,
   dua nomor, satu tombol, dan satu poster promo. Tidak ada keterangan
   soal usia bayi yang dilayani, jenis perawatannya, lama sesinya,
   jadwal, maupun harga.

   Saya sengaja TIDAK mengarangnya. Lihat catatan pada MANFAAT dan
   KETENTUAN di bawah.
   ============================================================ */

/* ============================================================
   POSTER

   ⚠️ PERIKSA EKSTENSINYA. Kamu menyimpan berkasnya di
   public/images/ dengan nama "baby-spa", tapi saya tidak tahu
   ekstensinya. Sesuaikan baris `src` di bawah:

     .jpg  -> "/images/baby-spa.jpg"
     .png  -> "/images/baby-spa.png"
     .webp -> "/images/baby-spa.webp"

   Yang tertulis harus SAMA PERSIS dengan nama berkas di disk,
   termasuk huruf besar-kecilnya. Windows tidak membedakan, server
   produksi membedakan - berkas yang tampil di komputermu bisa hilang
   begitu situsnya online.

   Kalau path-nya salah, halaman tidak rusak: bagian posternya
   disembunyikan sendiri.

   ============================================================
   ⚠️⚠️ POSTERNYA ADALAH PROMO MUSIMAN, BUKAN INFORMASI TETAP

   Poster yang kamu pakai berbunyi "PROMO SPESIAL EDISI HARI
   KEMERDEKAAN". Itu penawaran yang terikat tanggal - 17 Agustus - dan
   halaman ini akan tetap tayang sepanjang tahun.

   Dua akibatnya, dan keduanya nyata:

     1. Bulan Maret, pengunjung melihat promo kemerdekaan dan
        menyimpulkan halaman ini sudah lama tidak diurus. Kesan itu
        menular ke seluruh situs.

     2. Lebih serius: seseorang datang membawa tangkapan layar poster
        itu dan menuntut harganya. Penawaran yang masih terpampang di
        situs resmi rumah sakit sulit ditolak di depan kasir, meski
        periodenya sudah lewat berbulan-bulan.

   `promo: true` di bawah membuat halaman menampilkan keterangan bahwa
   penawarannya terbatas waktu dan perlu dipastikan dulu. Itu menambal,
   bukan menyelesaikan.

   YANG BENAR-BENAR MENYELESAIKAN, urut dari yang terbaik:

     1. Ganti dengan foto ruang baby spa atau foto kegiatannya. Foto
        seperti itu tidak pernah kedaluwarsa dan justru lebih
        meyakinkan orang tua daripada poster diskon.

     2. Kalau posternya memang harus promo, isi `berlaku` di bawah
        dengan tanggal berakhirnya, lalu SETEL PENGINGAT untuk
        menggantinya. Tanggalnya akan tampil di halaman.

     3. Kalau promonya sudah lewat, kosongkan `src` - bagian posternya
        hilang, dan halaman tetap utuh tanpanya.
   ============================================================ */
export const FOTO = {
  src: "/images/baby.png",

  alt: {
    id: "Poster promo layanan Baby Spa RS Jakarta Medical Center.",
    en: "Baby spa promotional poster of Jakarta Medical Center Hospital.",
  },

  /* Setel false kalau posternya sudah diganti dengan foto biasa -
     keterangan "penawaran terbatas waktu" akan hilang dengan
     sendirinya. */
  promo: true,

  /* Kosongkan kalau tidak ingin menampilkan tanggal. Ditulis sebagai
     teks, bukan tanggal, supaya bisa diisi "31 Agustus 2026" maupun
     "selama persediaan berlangsung". */
  berlaku: { id: "", en: "" },
};

/* ============================================================
   NOMOR

   Customer Service jadi tombol utama - sama dengan halaman lama, dan
   memang tepat di sini: baby spa dipesan lewat penjadwalan, dan CS
   yang memegang jadwalnya.

   Nomor hunting sengaja TIDAK diberi medan `wa`. Ia sambungan telepon
   ke operator, bukan nomor WhatsApp; tautan WhatsApp ke sana membuka
   percakapan yang tidak pernah dibaca siapa pun.
   ============================================================ */
export const BABY_SPA = {
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin melakukan reservasi layanan Baby Spa.\n\nMohon informasi jadwal dan ketentuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to book the baby spa service.\n\nPlease let me know the available schedule and requirements. Thank you.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};

/* ============================================================
   MANFAAT - SENGAJA KOSONG

   Godaan terbesar saat mengisi halaman baby spa adalah menuliskan
   daftar manfaat: memperbaiki kualitas tidur, melancarkan pencernaan,
   menguatkan otot, dan seterusnya. Kalimat-kalimat itu mudah ditemukan
   di internet dan enak dibaca.

   Saya tidak menuliskannya, dan sebaiknya kamu juga tidak - kecuali
   RS yang menyusunnya.

   Alasannya: itu KLAIM KESEHATAN pada bayi, dipublikasikan atas nama
   rumah sakit. Bobotnya berbeda dengan klaim yang sama di situs
   penyedia jasa biasa. Yang berhak menyusunnya adalah dokter anak atau
   fisioterapis yang menangani layanan ini - bukan saya, dan bukan
   tulisan dari situs lain.

   Kalau sudah disusun RS, isi seperti ini dan bagiannya muncul
   sendiri di halaman:

     { judul: { id: "...", en: "..." },
       isi:   { id: "...", en: "..." } },
   ============================================================ */
export const MANFAAT = [];

/* ============================================================
   KETENTUAN - SENGAJA KOSONG

   Yang paling dicari orang tua sebelum memesan, dan tidak satu pun
   ada di halaman lama:

     - usia bayi yang dilayani, batas bawah maupun batas atas
     - lama satu sesi
     - hari dan jam layanan
     - biaya
     - apakah bayi perlu diperiksa dokter dulu
     - kondisi yang membuat bayi tidak boleh ikut, misalnya sedang
       demam atau baru saja imunisasi
     - apa yang perlu dibawa

   Butir terakhir dan butir sebelum itu bersifat medis - minta bagian
   terkait yang menuliskannya.

   Isi seperti ini, bagiannya muncul sendiri:

     { label: { id: "Usia", en: "Age" },
       nilai: { id: "...", en: "..." } },
   ============================================================ */
export const KETENTUAN = [];

/* ============================================================
   CARA RESERVASI

   ⚠️ DRAF - BELUM DIKONFIRMASI RS.

   Halaman lama hanya menulis "silakan hubungi nomor di bawah untuk
   melakukan reservasi" tanpa menjelaskan alurnya. Ketiga langkah ini
   saya susun dari alur penjadwalan yang lazim, BUKAN dari keterangan
   RS.

   Yang perlu dipastikan ke bagian terkait:
     - berapa lama sebelumnya harus memesan
     - apakah ada uang muka
     - apakah pendaftaran bisa langsung datang tanpa janji

   Kalau alurnya berbeda, ubah teksnya di sini - komponennya tidak
   perlu disentuh. Kalau RS belum bisa memastikan, KOSONGKAN array
   ini; bagiannya hilang sendiri, dan itu jauh lebih baik daripada
   memajang alur yang keliru.
   ============================================================ */
export const LANGKAH = [
  {
    judul: { id: "Hubungi Customer Service", en: "Contact Customer Service" },
    isi: {
      id: "Kirim pesan lewat WhatsApp atau telepon untuk menanyakan jadwal yang tersedia.",
      en: "Message us on WhatsApp or call to ask about available time slots.",
    },
  },
  {
    judul: { id: "Tentukan jadwal", en: "Choose a time" },
    isi: {
      id: "Sampaikan usia bayi dan waktu yang Anda inginkan, lalu petugas akan mengonfirmasi jadwalnya.",
      en: "Tell us your baby's age and your preferred time, and our staff will confirm the booking.",
    },
  },
  {
    judul: { id: "Datang sesuai jadwal", en: "Come at the scheduled time" },
    isi: {
      id: "Datang ke RS JMC pada waktu yang telah dikonfirmasi.",
      en: "Come to JMC Hospital at the confirmed time.",
    },
  },
];
